module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "faces-detected"
    }
  }, [(_vm.searching) ? _c('div', [_c('strong', [_vm._v("Searching. Please wait...")])]) : _vm._e(), _vm._v(" "), (!_vm.searching && (!_vm.faces || (_vm.faces.length && _vm.faces[0].merged_matches))) ? _c('div', [_c('h1', [_vm._v("Potential Matches")])]) : _vm._e(), _vm._v(" "), (_vm.faces && _vm.faces.length && !_vm.searching) ? _c('div', {
    staticClass: "faces-list"
  }, [_vm._v("\n    Click a picture to confirm. The number before the name is the match difference; smaller numbers are stronger matches.\n    "), (_vm.new_results && _vm.new_results > 0) ? _c('div', {
    attrs: {
      "id": "new-results"
    }
  }, [_vm._v("\n      Have " + _vm._s(_vm.new_results) + " new result" + _vm._s(_vm.new_results > 1 ? 's' : '') + ". "), _c('a', {
    attrs: {
      "href": "#/detected"
    },
    on: {
      "click": _vm.updateResults
    }
  }, [_vm._v("Refresh")]), _vm._v(" to load.\n    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.faces), function(face) {
    return _c('div', {
      key: face.runtime_face_uuid,
      staticClass: "faces-list-entry"
    }, [_c('div', {
      staticClass: "faces-list-entry-info"
    }, [_c('div', {
      staticClass: "camera-description"
    }, [_vm._v(_vm._s(face.camera_description || face.camera_fname))]), _vm._v(" "), _c('div', {
      attrs: {
        "claas": "captured-at-diff"
      }
    }, [_vm._v(_vm._s(_vm.getTimeDiff(face.captured_at)))]), _vm._v(" "), _c('div', {
      staticClass: "captured-at-string"
    }, [_vm._v(_vm._s(_vm.getTimeString(face.captured_at)))]), _vm._v(" "), _c('div', [_vm._v("Confidence=" + _vm._s(_vm.confidenceformat(face.face_confidence)))]), _vm._v(" "), _c('div', [_vm._v("Face Height: " + _vm._s(face.face_height))])]), _vm._v(" "), _c('div', {
      staticClass: "face-image-area"
    }, [_c('a', {
      attrs: {
        "href": face.frame_uri,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "the-image",
      attrs: {
        "src": 'https://yakov.owal.io/api/v6/faces/images/' + face.runtime_face_uuid + '?shape=1&clahe=1',
        "height": "144"
      }
    })])]), _vm._v(" "), (face.merged_matches && face.merged_matches.length > 1) ? _c('div', {
      staticClass: "merged-matches-area"
    }, [_vm._l((face.merged_matches.slice(1, 4)), function(merged_match) {
      return _c('img', {
        key: merged_match.runtime_face_uuid,
        staticClass: "the-image",
        attrs: {
          "src": _vm.BASE_URL + '/api/v4/faceimage/' + merged_match.runtime_face_uuid,
          "height": "144"
        }
      })
    }), _vm._v(" "), (face.merged_matches.length > 4) ? _c('div', [_vm._v("\n          ... plus " + _vm._s(face.merged_matches.length - 4) + " more\n        ")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (face.matches && face.matches.length && (typeof _vm.not_match_filter[face.runtime_face_uuid] === 'undefined')) ? _c('div', {
      staticClass: "matches-area"
    }, _vm._l((face.matches), function(potential_match) {
      return _c('div', {
        key: potential_match.frontend_face_uuid,
        staticClass: "potential-match"
      }, [_c('img', {
        directives: [{
          name: "lazy",
          rawName: "v-lazy",
          value: (potential_match.image_uri),
          expression: "potential_match.image_uri"
        }],
        style: ({
          border: (potential_match.is_exact || face.matches.indexOf(potential_match) == 0 ? 2 : 0) + 'px solid ' + (potential_match.is_exact ? 'green' : 'orange')
        }),
        attrs: {
          "height": face.matches.indexOf(potential_match) == 0 ? 160 : 120
        },
        on: {
          "click": function($event) {
            _vm.faceMatchConfirm(face.runtime_face_uuid, potential_match.frontend_face_uuid, true)
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "potential-match-name-area"
      }, [(!potential_match.is_exact && potential_match.diff) ? _c('div', {
        style: ({
          background: _vm.colorForMatch(potential_match.diff)
        }),
        attrs: {
          "id": "circle"
        }
      }) : _vm._e(), _vm._v(_vm._s(_vm.diffformat(potential_match.diff)) + " \n            "), (!potential_match.is_exact && potential_match.confidence) ? _c('div', {
        style: ({
          background: _vm.colorForMatchConfidence(potential_match.confidence)
        }),
        attrs: {
          "id": "circle"
        }
      }) : _vm._e(), _vm._v(" " + _vm._s(_vm.confidenceformat(potential_match.confidence)) + " \n            "), _c('router-link', {
        staticClass: "potential-match-name",
        attrs: {
          "to": '/faces/' + potential_match.person_name
        }
      }, [_vm._v(_vm._s(potential_match.person_name))])], 1)])
    })) : _vm._e(), _vm._v(" "), (typeof _vm.not_match_filter[face.runtime_face_uuid] !== 'undefined') ? _c('div', {
      staticClass: "enter-name-area"
    }, [_c('div', {
      staticClass: "enter-name-query-area"
    }, [_c('div', [_vm._v("Who is this?")]), _vm._v(" "), _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.not_match_filter[face.runtime_face_uuid]),
        expression: "not_match_filter[face.runtime_face_uuid]"
      }],
      domProps: {
        "value": (_vm.not_match_filter[face.runtime_face_uuid])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.not_match_filter, face.runtime_face_uuid, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "ui button",
      on: {
        "click": function($event) {
          _vm.visitor(face.runtime_face_uuid)
        }
      }
    }, [_vm._v("Visitor")])]), _vm._v(" "), _c('div', {
      staticClass: "enter-name-matches-area"
    }, _vm._l((_vm.filteredMatches(face.runtime_face_uuid)), function(filtered_match) {
      return _c('div', {
        key: filtered_match.frontend_face_uuid,
        staticClass: "enter-name-match"
      }, [_c('img', {
        directives: [{
          name: "lazy",
          rawName: "v-lazy",
          value: (filtered_match.image_uri),
          expression: "filtered_match.image_uri"
        }],
        attrs: {
          "height": "120"
        },
        on: {
          "click": function($event) {
            _vm.faceMatchConfirm(face.runtime_face_uuid, filtered_match.frontend_face_uuid, true)
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "enter-name-match-name-area"
      }, [_c('router-link', {
        staticClass: "enter-name-match-name",
        attrs: {
          "to": '/faces/' + filtered_match.person_name
        }
      }, [_vm._v(_vm._s(filtered_match.person_name))])], 1)])
    }))]) : _vm._e(), _vm._v(" "), (!face.merged_matches && typeof _vm.not_match_filter[face.runtime_face_uuid] === 'undefined' && !face.matches.find(function (x) { return x.is_exact; })) ? _c('div', {
      staticClass: "not-a-face-area"
    }, [_c('p', [_c('button', {
      staticClass: "ui negative small basic button",
      on: {
        "click": function($event) {
          _vm.notAFace(face.runtime_face_uuid)
        }
      }
    }, [_vm._v("Not a face")])]), _vm._v(" "), _c('p', [_c('button', {
      staticClass: "ui small button",
      on: {
        "click": function($event) {
          _vm.notAMatch(face.runtime_face_uuid)
        }
      }
    }, [_vm._v("Person not listed?")])])]) : _vm._e()])
  }), _vm._v(" "), (!_vm.$route.params.frontend_face_uuid) ? _c('infinite-loading', {
    ref: "infiniteLoading",
    attrs: {
      "on-infinite": _vm.getMoreResults
    }
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (!_vm.searching && _vm.faces && !_vm.faces.length) ? _c('div', [_vm._v("\n    No results.\n  ")]) : _vm._e(), _vm._v(" "), (_vm.oldest_time) ? _c('div', [_vm._v("\n    Showing results up to " + _vm._s(_vm.oldest_time) + "\n  ")]) : _vm._e(), _vm._v(" "), (!_vm.searching && !_vm.loadingMore && _vm.$route.params.frontend_face_uuid) ? _c('div', [_c('button', {
    staticClass: "ui button",
    on: {
      "click": _vm.getMoreResults
    }
  }, [_vm._v("Load More")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d9cabf8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FacesDetected.vue
// module id = 299
// module chunks = 1